import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2e42a066&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=2e42a066&lang=scss&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e42a066",
  null
  
)

export default component.exports